import { iWizardWorker } from "../interfaces/workers";
import { changeConnection } from "../state/connection";
import store from "../state/store";
import { getSessionValue, removeSessionValue, saveSessionValue } from "./localStore/calls";
import { deactivateEnquiryWizard } from "../interfaces/enquiryList";
import { callApi, iRequest } from "./apiCall";
import { removeTab } from "../state/tabRow";
import { Wizard } from "../state/workflowSlice";
import { iTenant } from "../interfaces/auth";
import { KeepAlive } from "../Logic/EmsAPI/EnquiryAction";
export async function keepTheConnectionAlive(enquiryId: number): Promise<any> {
    return new Promise(async (resolve, reject) => {
        try {
            if (getSpecificWorkerFromSession(enquiryId) == undefined) {
                var tenantInfo = getSessionValue<iTenant>("tenant");
                if (tenantInfo == null || tenantInfo == undefined) {
                    reject("No tenant found");
                    return;
                }

                let request: iRequest = {
                    url: "Enquiry/" + enquiryId + "/Action",
                    method: "GET",
                    headers: [],
                    body: "",
                    responseType: "json",
                };
                const misResponse = await callApi(request);
                addWorkerProcessToSession(enquiryId);
                resolve(misResponse);
            } else {
                resolve("success");
            }
        } catch (err) {
            reject(err);
        }
    });
}

export async function closeAllWizards(): Promise<void> {
    const wizards = getSessionValue<Wizard[]>("Workflows") ?? [];
    for (const wizard of wizards) {
        await closeConnection(wizard.EnquiryId);
        store.dispatch(removeTab(wizard.EnquiryId));
    }
}

export async function closeConnection(divId: number): Promise<any> {
    deleteWorkerProcessFromSession(divId);
    await deactivateEnquiryWizard(divId);
    return "success";
}

export const addWorkerProcessToSession = (enquiryId: number) => {
    let allWorkers: number[] = [];
    const workers = getSessionValue<number[]>("activeWizards");
    if (workers !== null) {
        allWorkers = workers.filter(x => x != enquiryId);
    }
    allWorkers.push(enquiryId);
    saveSessionValue("activeWizards", allWorkers);
};

export const getactiveWizardsFromSession = (): Array<number> => {
    return getSessionValue<number[]>("activeWizards") ?? [];
};

export const getSpecificWorkerFromSession = (enquiryId: number): number | undefined => {
    return getSessionValue<number[]>("activeWizards")?.find(w => w === enquiryId);
};

export const deleteWorkerProcessFromSession = (enquiryId: number) => {
    let allWorkers: number[] = [];
    let workers = getSessionValue<number[]>("activeWizards");
    if (workers !== null) {
        allWorkers = workers.filter(x => x != enquiryId);
    }
    if (allWorkers.length === 0) removeSessionValue("activeWizards");
    else {
        saveSessionValue("activeWizards", allWorkers);
    }

    allWorkers = [];
    workers = getSessionValue<number[]>("forbiddenActiveWizards");
    if (workers !== null) {
        allWorkers = workers.filter(x => x != enquiryId);
    }
    if (allWorkers.length === 0) removeSessionValue("forbiddenActiveWizards");
    else {
        saveSessionValue("forbiddenActiveWizards", allWorkers);
    }
};

export const keepActiveWizardsAlive = async () => {
    let activeWizards = getSessionValue<number[]>("activeWizards");
    removeSessionValue("forbiddenActiveWizards");
    let fAW: number[] = [];
    let allCalls: Array<{ call: Promise<any>; id: number }> = [];
    if (activeWizards != null) {
        for (let i = 0; i < activeWizards.length; i++) {
            allCalls.push({ call: KeepAlive(activeWizards[i]), id: activeWizards[i] });
        }
        Promise.all(allCalls.flatMap(x => x.call)).then(results => {
            for (let c = 0; c < results.length; c++) {
                if (results[c].status == 403) {
                    fAW.push(allCalls[c].id);
                }

                if (!results[c].isOk && results[c].status == 400) {
                    activeWizards = activeWizards!.filter(x => x != allCalls[c].id);
                    saveSessionValue("activeWizards", activeWizards);
                }
            }
            saveSessionValue("forbiddenActiveWizards", fAW);
        });
    }
};
